import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: block;
`;
export const SideBar = ({ className }: { className?: string }) => {
  return <Wrapper className={className}>sidebar</Wrapper>;
};
